<template>
  <div>
    <template v-if="account.isTournament">
      <TournamentInfo />
    </template>
    <template v-else>
      <div v-if="tournamentsIsVisible" class="row">
        <div class="col">
          <!-- <TournamentScroller class="mb-6" /> -->
          <!--commented out from user profile page -->
        </div>
      </div>
      <div v-if="account._canEdit" class="row">
        <div class="col col-md-10 offset-md-1 mb-6">
          <CreatePost :author-model="account" @post-created="appendNewPost" />
        </div>
      </div>
      <div class="row">
        <div class="col feeds-wrapper">
          <component :is="!posts.length ? 'Panel' : 'div'">
            <!-- <TextLabel
            :text="
              $t('_web_newsfeed_feed-label', `{name}'s Neewsfeed`, {
                name: account._name,
              })
            "
            class="mb-3"
          /> -->
            <ListLoader
              :is-loading="isLoading"
              :is-crashed="isCrashed"
              :is-empty-list="!posts.length"
              :dummy-props="{
                iconName: 'dummy/newsfeed',
                size: 200,
                headerText: $t('_web_empty-wall', 'This feed is empty'),
                text: $t(
                  '_web_empty-wall_subheader',
                  'It seems there are no shared news, insights, or other interesting stuff'
                ),
              }"
              @reload="reloadPage"
            >
              <infiniteScroll
                v-if="posts && posts.length"
                slot="list"
                :list="posts"
                list-name="posts"
                :is-disabled="listIsDisabled"
                @ScrollToBottom="fetchPosts"
              >
                <div
                  ref="popoverClosest"
                  slot-scope="{}"
                  class="position-relative"
                >
                  <template v-for="post in posts">
                    <CreatePost
                      v-if="
                        !$lodash.isEmpty(post.post || post) &&
                          postToEdit === post.post.id
                      "
                      :key="post.id"
                      :author-model="account"
                      :post-model="post.post"
                      class="mb-6"
                      @post-created="updatePost"
                      @post-cancel="cancelEdit"
                    />
                    <Post
                      :key="post.id"
                      v-observe-visibility="{
                        callback: isVisible =>
                          handleScrollIntoViewForViewsTracking(
                            isVisible,
                            post.id,
                            'post'
                          ),
                        intersection: {
                          threshold: 0.1,
                        },
                      }"
                      :post="post.post || post"
                      :type="post.post_type"
                      class="mb-5"
                      @dotsClick="openPopoverMenu($event, post)"
                    />
                  </template>

                  <PostPopover
                    class="profile-share-menu"
                    :position="popoverPosition"
                    :closest="$refs.popoverClosest"
                    :post="popoverPost"
                    @edit="editPost"
                    @deleted="removePost"
                    @pinned="updatePost"
                    @toggle="closePopover"
                  />
                </div>
              </infiniteScroll>
            </ListLoader>
          </component>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import listMixin from '@/mixins/lists';

import CreatePost from '@/components/posts/CreatePost.vue';
import Post from '@/components/posts/PostItem.vue';
import infiniteScroll from '@/components/common/InfiniteScroll';
import PostPopover from '@/components/posts/PostPopover';
import ListLoader from '@/components/common/HeraListPreloader';
import TournamentScroller from '@/views/account/content/feeds/components/TournamentsScroller';
import TextLabel from '@/components/atoms/TextLabel';
import Panel from '@/components/atoms/Panel';
import TournamentInfo from '@/views/account/content/info/Tournament';
import * as ACCOUNT from '@/constants/accounts';
import viewsTrackingMixin from '@/mixins/metrics';
export default {
  name: 'AccountFeeds',
  components: {
    CreatePost,
    Post,
    infiniteScroll,
    PostPopover,
    ListLoader,
    TournamentScroller,
    TextLabel,
    Panel,
    TournamentInfo,
  },
  mixins: [...listMixin, viewsTrackingMixin],
  data() {
    return {
      posts: [],
      postToEdit: '',
      popoverPosition: null,
      popoverPost: null,
    };
  },
  computed: {
    ...mapState('current', ['account', 'accountType', 'accountId']),
    ...mapGetters(['modalIsShow']),
    tournamentsIsVisible() {
      return [ACCOUNT.PROFILE, ACCOUNT.CLAN].includes(this.accountType);
    },
  },
  created() {
    // debugger;
    if (!this.account.isTournament) {
      this.fetchPosts();
    }
  },
  methods: {
    ...mapActions(['fetchAccountWall', 'errorNotify']),
    fetchPosts() {
      return this.getNextPageData(
        'posts',
        this.fetchAccountWall({
          accountId: this.accountId,
          accountType: this.accountType,
          pageToken: this.nextPageToken,
        })
      ).catch(this.errorNotify);
    },
    reloadPage() {
      this.fetchPosts();
    },
    editPost(post) {
      if (post) {
        this.postToEdit = post.id;
      }
    },
    updatePost(post) {
      if (post) {
        this.posts = this.posts.map(element => {
          if (element.post.id == post.id) {
            element.post = post.post;
            element.post.id = post.id;
            this.postToEdit = '';
          }
          return element;
        });
      }
    },
    cancelEdit(post) {
      if (post) this.postToEdit = '';
    },
    appendNewPost(post) {
      this.posts = [post, ...this.posts];
    },
    removePost(post) {
      this.posts = this.posts.filter(item => item.post.id !== post.id);
      this.closePopover(false);
    },
    closePopover(visible) {
      if (!visible && !this.modalIsShow) {
        this.popoverPosition = null;
        /* commented, because modal opened after this function and PostPopover can not delete post (=== null)
        this.popoverPost = null;
        */
      }
    },
    openPopoverMenu(position, { post }) {
      this.popoverPosition = position;
      this.popoverPost = post;
    },
  },
};
</script>
<style lang="scss">
.feeds-wrapper {
  min-height: 14rem;
  .list-loader {
    .list-loader_wrapper {
      position: relative;
    }
  }
}
.dropbox-menu li > *:not(hr) {
  padding-left: 5px !important;
  padding-right: 5px !important;
  height: 35px !important;
}
</style>
